import { Form, Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import React, { useState, useContext } from "react";
import { AuthContext } from "../../AuthProvider";
import Parse from "parse";
import "./HotWaterLowPrice.css";

const HotWaterLowPrice = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const { esp, updateUserEsp, setUserEsp } = useContext(AuthContext);

    const handleCloseModal = () => {
        setModalIsOpen(false);
    };

    const handleInputChange = (change) => {
        const oldValue = esp.hotWater.lowPriceLimit || 0;
        const newValue = parseFloat((oldValue + change).toFixed(1));
        if (newValue > -1 && newValue < 10 && newValue <= oldValue + 1 && newValue >= oldValue - 1) {
            updateUserEsp(esp.id, { hotWater: { lowPriceLimit: newValue } })
                .then((result) => {
                    Parse.Cloud.run("updateHotWaterHours", { espId: esp.id })
                        .then((updateResult) => {
                            setUserEsp(updateResult)
                        });
                });
        }
    };

    const openModal = () => {
        setModalIsOpen(true);
    };

    return (
        <>
            <button onClick={openModal} className="controlpanel-button">
                <i className="bi bi-arrow-bar-down controlpanel-button-lowprice-icon text-success" style={{ position: 'absolute', top: '0%' }} />
                <span className="controlpanel-button-lowprice-number" style={{ position: 'absolute', top: '0%' }}>{esp?.hotWater?.lowPriceLimit}&nbsp;kr</span>
                <span className="controlpanel-button-lowprice-text" style={{ position: 'absolute', top: '39%' }}>Lågprisgräns</span>
            </button>
            <Modal show={modalIsOpen} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Lågprisgräns</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="hotwaterLowPriceLimit">
                        <div className="d-flex align-items-center">
                            <div style={{ width: '70px' }}>
                                <strong>Prisgräns</strong>
                            </div>
                            <div className="d-flex align-items-center" style={{ width: '120px' }}>
                                <i className="bi bi-dash ms-2" onClick={() => handleInputChange(-0.1)} style={{ cursor: 'pointer' }} />
                                <span className="mx-2">{esp?.hotWater?.lowPriceLimit}&nbsp;kr</span>
                                <i className="bi bi-plus" onClick={() => handleInputChange(0.1)} style={{ cursor: 'pointer' }} />
                            </div>
                        </div>
                        <div>
                            <p><small>Ställ in gränsen för lågpris där varmvattnet värms kontinuerligt när priset är lägre än denna gräns.</small></p>
                        </div>
                    </Form.Group>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default HotWaterLowPrice;


